var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90256 12.4999C3.48715 12.4999 2.77944 12.4999 2.27558 12.1978C1.94627 12.0003 1.68097 11.718 1.50975 11.3827C1.24778 10.8697 1.3182 10.1915 1.45904 8.83492C1.57661 7.70252 1.63539 7.13628 1.92448 6.72046C2.11427 6.44744 2.37098 6.22368 2.6719 6.06894C3.13024 5.83325 3.72101 5.83325 4.90256 5.83325H11.0973C12.2789 5.83325 12.8696 5.83325 13.3279 6.06894C13.6289 6.22368 13.8856 6.44744 14.0754 6.72046C14.3645 7.13628 14.4233 7.70252 14.5408 8.83492C14.6817 10.1915 14.7521 10.8697 14.4901 11.3827C14.3189 11.718 14.0536 12.0003 13.7243 12.1978C13.2204 12.4999 12.5127 12.4999 11.0973 12.4999",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 5.83325V4.49992C11.3334 3.24284 11.3334 2.6143 10.9429 2.22378C10.5523 1.83325 9.92381 1.83325 8.66675 1.83325H7.33341C6.07633 1.83325 5.44779 1.83325 5.05727 2.22378C4.66675 2.6143 4.66675 3.24284 4.66675 4.49992V5.83325",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32588 11.1667H6.67428C6.21743 11.1667 5.989 11.1667 5.79464 11.2393C5.53549 11.3361 5.31359 11.5241 5.16422 11.7733C5.05218 11.9603 4.99678 12.2008 4.88598 12.6817C4.71284 13.4331 4.62627 13.8087 4.68514 14.11C4.76365 14.5117 5.00833 14.8517 5.34843 15.0317C5.6035 15.1667 5.96043 15.1667 6.67428 15.1667H9.32588C10.0397 15.1667 10.3967 15.1667 10.6517 15.0317C10.9918 14.8517 11.2365 14.5117 11.315 14.11C11.3739 13.8087 11.2873 13.4331 11.1142 12.6817C11.0034 12.2008 10.9479 11.9603 10.8359 11.7733C10.6865 11.5241 10.4647 11.3361 10.2055 11.2393C10.0111 11.1667 9.78275 11.1667 9.32588 11.1667Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.5H12.0062",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/pn.bbf6bca6e2ad44696332248aeae297e4.svg";
export { ForwardRef as ReactComponent };